import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-0">
      
      {/* Metalik Küre 1 - Büyük - Yukarı aşağı */}
      <div className="absolute top-1/4 right-1/5 w-96 h-96 opacity-40 animate-move-up" style={{ animationDelay: '0s', transform: 'translate3d(0, 30px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 35% 35%, #FFEF9F, #FFDD59, #E6C84D, #CDB338, #997A00, #4D3D00)',
               boxShadow: 'inset -20px -20px 60px rgba(0,0,0,0.4), inset 10px 10px 40px rgba(255,255,255,0.3), 0 0 80px rgba(255,221,89,0.3)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 2 - Orta - Çapraz aşağı */}
      <div className="absolute bottom-1/4 left-1/6 w-80 h-80 opacity-45 animate-move-diagonal-down" style={{ animationDelay: '1s', transform: 'translate3d(-20px, -20px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 40% 40%, #FFF9E6, #FFDD59, #FFD033, #CCA300, #997700, #664D00)',
               boxShadow: 'inset -15px -15px 50px rgba(0,0,0,0.3), inset 8px 8px 35px rgba(255,255,255,0.4), 0 0 70px rgba(255,221,89,0.25)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 3 - Büyük - Sağdan sola */}
      <div className="absolute top-1/2 left-1/3 w-88 h-88 opacity-35 animate-move-left" style={{ animationDelay: '2s', transform: 'translate3d(30px, 0, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 30% 30%, #FFFACD, #FFED4E, #FFDD59, #E6C200, #B8991A, #8B7500)',
               boxShadow: 'inset -18px -18px 55px rgba(0,0,0,0.35), inset 12px 12px 38px rgba(255,255,255,0.35), 0 0 75px rgba(255,221,89,0.28)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 4 - Orta - Aşağı */}
      <div className="absolute bottom-1/3 right-1/4 w-72 h-72 opacity-50 animate-move-down" style={{ animationDelay: '1.5s', transform: 'translate3d(0, -30px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 38% 38%, #FFFCE6, #FFE75C, #FFDD59, #D4B83E, #A89232, #6B5E00)',
               boxShadow: 'inset -12px -12px 45px rgba(0,0,0,0.3), inset 10px 10px 30px rgba(255,255,255,0.45), 0 0 65px rgba(255,221,89,0.3)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 5 - Küçük - Soldan sağa */}
      <div className="absolute top-2/3 left-1/5 w-64 h-64 opacity-45 animate-move-right" style={{ animationDelay: '2.5s', transform: 'translate3d(-30px, 0, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 42% 42%, #FFFEF0, #FFF176, #FFDD59, #CCAA00, #998000, #665500)',
               boxShadow: 'inset -10px -10px 40px rgba(0,0,0,0.25), inset 8px 8px 28px rgba(255,255,255,0.5), 0 0 60px rgba(255,221,89,0.32)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 6 - Orta - Çapraz yukarı */}
      <div className="absolute bottom-1/5 right-1/3 w-76 h-76 opacity-40 animate-move-diagonal-up" style={{ animationDelay: '3s', transform: 'translate3d(20px, 20px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 36% 36%, #FFFFF0, #FFE95F, #FFDD59, #D9B840, #AA8F2E, #7A6400)',
               boxShadow: 'inset -14px -14px 48px rgba(0,0,0,0.32), inset 9px 9px 32px rgba(255,255,255,0.42), 0 0 68px rgba(255,221,89,0.29)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 7 - Büyük - Sağdan sola */}
      <div className="absolute top-1/3 right-2/3 w-92 h-92 opacity-38 animate-move-left" style={{ animationDelay: '3.5s', transform: 'translate3d(30px, 0, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 33% 33%, #FFFDF5, #FFEB66, #FFDD59, #CFAD3D, #A18628, #776300)',
               boxShadow: 'inset -16px -16px 52px rgba(0,0,0,0.33), inset 11px 11px 36px rgba(255,255,255,0.38), 0 0 72px rgba(255,221,89,0.27)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 8 - Küçük - Yukarı */}
      <div className="absolute top-1/5 left-1/2 w-56 h-56 opacity-48 animate-move-up" style={{ animationDelay: '4s', transform: 'translate3d(0, 30px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 45% 45%, #FFFFFF, #FFF480, #FFDD59, #D1B03F, #9D8025, #5C4D00)',
               boxShadow: 'inset -8px -8px 35px rgba(0,0,0,0.22), inset 7px 7px 25px rgba(255,255,255,0.55), 0 0 55px rgba(255,221,89,0.35)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 9 - Orta - Aşağı */}
      <div className="absolute bottom-2/5 left-2/3 w-68 h-68 opacity-42 animate-move-down" style={{ animationDelay: '0.5s', transform: 'translate3d(0, -30px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 39% 39%, #FFFEFA, #FFEC70, #FFDD59, #C8A83C, #968329, #6A5700)',
               boxShadow: 'inset -11px -11px 42px rgba(0,0,0,0.28), inset 8px 8px 29px rgba(255,255,255,0.48), 0 0 62px rgba(255,221,89,0.31)'
             }}>
        </div>
      </div>
      
      {/* Metalik Küre 10 - Küçük - Çapraz aşağı */}
      <div className="absolute top-3/5 right-1/5 w-60 h-60 opacity-46 animate-move-diagonal-down" style={{ animationDelay: '1.8s', transform: 'translate3d(-20px, -20px, 0)' }}>
        <div className="w-full h-full rounded-full" 
             style={{ 
               background: 'radial-gradient(circle at 41% 41%, #FFFFFA, #FFF070, #FFDD59, #BFA238, #8E7A1F, #5A4800)',
               boxShadow: 'inset -9px -9px 38px rgba(0,0,0,0.26), inset 7px 7px 27px rgba(255,255,255,0.52), 0 0 58px rgba(255,221,89,0.33)'
             }}>
        </div>
      </div>
      
    </div>
  );
};

export default AnimatedBackground;
